import exoBridge from './exoBridge'
export default exoBridge
